/* eslint @typescript-eslint/no-explicit-any: "off" */
import React from "react";
import { I18n } from "@aws-amplify/core";
import { TOTPSetup } from "aws-amplify-react";
import { withStyles } from "@material-ui/core/styles";

import { AuthWrapper, styles } from "./AuthWrapper";
import { TotpEnrolment } from "./TotpEnrolment";

/**
 * Shown when Cognito answers sign-in with an MFA_SETUP challenge -- that is, MFA is
 * required and this user has no authenticator registered yet.
 *
 * Reached two ways:
 *  - a new user finishing their first-login password change (RequireNewPassword
 *    chains straight here), and
 *  - an existing user signing in for the first time after MFA became REQUIRED.
 *
 * The stock TOTPSetup renders unstyled aws-amplify-react markup, and the Amplify UI
 * stylesheet is not loaded in this app, so it has to be replaced rather than themed.
 */
class CustomTOTPSetup extends TOTPSetup {
  constructor(props: any) {
    super(props);
    this._validAuthStates = ["TOTPSetup"];
  }

  showComponent() {
    const user = this.props.authData;

    return (
      <AuthWrapper
        title={I18n.get("Admin Login")}
        subtitle={I18n.get("Set up two-factor authentication")}
      >
        <TotpEnrolment
          user={user}
          // checkContact is TOTPSetup's own post-enrolment step: it moves to
          // signedIn, or to verifyContact if contact details still need verifying.
          onComplete={(enrolled) => this.checkContact(enrolled)}
          submitLabel={I18n.get("Verify and sign in")}
        />
      </AuthWrapper>
    );
  }
}

export default withStyles(styles)(CustomTOTPSetup);
